<div class="details-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">{{ sub?._invoiceView ? 'receipt' : 'subscriptions' }}</mat-icon>
      <ng-container *ngIf="sub?._invoiceView; else subscriptionTitle">
        {{ 'INVOICE' | translate }} – {{ sub?.invoice_no || '—' }}
      </ng-container>
      <ng-template #subscriptionTitle>
        {{ 'SUBSCRIPTION' | translate }} #{{ sub?.id }} – {{ 'DETAILS' | translate }}
      </ng-template>
    </h2>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <ng-container *ngIf="sub?._invoiceView">
      <section class="summary-grid">
        <article class="summary-card is-primary">
          <p class="summary-label">{{ 'INVOICE' | translate }} #</p>
          <p class="summary-value">{{ sub?.invoice_no || '—' }}</p>
        </article>
        <article class="summary-card">
          <p class="summary-label">{{ 'TOTAL_AMOUNT' | translate }}</p>
          <p class="summary-value amount">₹{{ sub?.total ?? sub?.total_amount ?? '—' }}</p>
        </article>
      </section>

      <section class="details-grid">
        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">calendar_today</mat-icon>
            Date
          </p>
          <p class="section-value">{{ sub?.created_at ? (sub.created_at | date:'medium') : '—' }}</p>
        </article>
        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">tag</mat-icon>
            {{ 'SUBSCRIPTION' | translate }} #
          </p>
          <p class="section-value">{{ sub?.id || '—' }}</p>
        </article>
      </section>
    </ng-container>
    <ng-container *ngIf="!sub?._invoiceView">
      <section class="summary-grid">
        <article class="summary-card is-primary">
          <p class="summary-label">{{ 'TOTAL_AMOUNT' | translate }}</p>
          <p class="summary-value amount">₹{{ sub?.total_amount ?? '—' }}</p>
        </article>
        <article class="summary-card">
          <p class="summary-label">{{ 'STATUS' | translate }}</p>
          <span class="status-chip" [ngClass]="getStatusClass(sub)">{{ getStatusText(sub) }}</span>
        </article>
        <article class="summary-card">
          <p class="summary-label">{{ 'PAYMENT_STATUS' | translate }}</p>
          <span class="status-chip" [ngClass]="getPaymentStatusClass(sub)">{{ getPaymentStatusLabel(sub) }}</span>
        </article>
      </section>

      <section class="details-grid">
        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">corporate_fare</mat-icon>
            {{ 'ORGANIZATION_ID' | translate }}
          </p>
          <p class="section-value">{{ sub?.organization_id || '—' }}</p>
        </article>

        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">workspace_premium</mat-icon>
            Subscription type
          </p>
          <p class="section-value">{{ getSubscriptionUserTypeLabel(sub) }}</p>
        </article>

        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">event_available</mat-icon>
            {{ 'START_DATE_' | translate }}
          </p>
          <p class="section-value">{{ sub?.membership_start_date ? (sub.membership_start_date | date:'mediumDate') : '—' }}</p>
        </article>

        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">event_busy</mat-icon>
            {{ 'END_DATE_' | translate }}
          </p>
          <p class="section-value">{{ sub?.membership_end_date ? (sub.membership_end_date | date:'mediumDate') : '—' }}</p>
        </article>

        <article class="detail-item" *ngIf="getStatusDetails(sub).daysRemaining != null">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">hourglass_bottom</mat-icon>
            {{ 'DAYS_REMAINING' | translate }}
          </p>
          <p class="section-value">{{ getStatusDetails(sub).daysRemaining }}</p>
        </article>

        <article class="detail-item">
          <p class="section-title">
            <mat-icon class="tile-icon" aria-hidden="true">schedule</mat-icon>
            Created
          </p>
          <p class="section-value">{{ sub?.created_at ? (sub.created_at | date:'medium') : '—' }}</p>
        </article>
      </section>

      <!-- Domain usage summary -->
      <section class="details-section domains" *ngIf="sub?.road || sub?.construction || sub?.education || sub?.utilities || sub?.consultancy">
        <h4 class="section-title">{{ 'DOMAIN_USAGE' | translate }}</h4>
        <ul class="domain-list">
          <li *ngIf="sub?.road?.users_count > 0">Road: {{ sub.road.users_count }} user(s)</li>
          <li *ngIf="sub?.construction?.users_count > 0">Construction: {{ sub.construction.users_count }} user(s)</li>
          <li *ngIf="sub?.education?.users_count > 0">Education: {{ sub.education.users_count }} user(s)</li>
          <li *ngIf="sub?.utilities?.users_count > 0">Utilities: {{ sub.utilities.users_count }} user(s)</li>
          <li *ngIf="sub?.consultancy?.users_count > 0">
            Consultancy:
            <ng-container *ngIf="sub.consultancy.projects || sub.consultancy_projects">
              {{ sub.consultancy.projects ?? sub.consultancy_projects }} project(s),
            </ng-container>
            {{ sub.consultancy.users_count }} user(s)
          </li>
        </ul>
      </section>
    </ng-container>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
    <button mat-raised-button color="primary" *ngIf="sub?._invoiceView" (click)="printInvoice()">
      <mat-icon>print</mat-icon> Print
    </button>
  </mat-dialog-actions>
</div>
